export default "__VITE_ASSET__BjGGc6Ll__"